<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-receipt" />
      模版管理
    </h4>
    <b-tabs pills>
      <!-- Tab: remarks -->
      <b-tab active  v-if="ability.can('read', 'settings_receipt_format')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-circle-info"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">模版資料</span>
        </template>
        <pdf-templates-list class="" />
      </b-tab>
      <!-- Tab: company -->
      <b-tab v-if="ability.can('read', 'settings_pdf_remark')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-comments"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">備註</span>
        </template>

        <remarks-list class="" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import remarksList from "./remark/remarks-list/remarksList.vue";
// import companysList from "./company/companys-list/companysList.vue";
import pdfTemplatesList from "./pdf-template/pdf-templates-list/pdfTemplatesList.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    remarksList,
    // companysList,
    pdfTemplatesList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data(){
    return{
      ability
    }
  },
  setup() {},
};
</script>
